import { render } from "./TrackMedicalApplication.vue?vue&type=template&id=229c675e&scoped=true"
import script from "./TrackMedicalApplication.vue?vue&type=script&lang=js"
export * from "./TrackMedicalApplication.vue?vue&type=script&lang=js"

import "./TrackMedicalApplication.vue?vue&type=style&index=0&id=229c675e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229c675e"]])

export default __exports__